<template>
  <v-dialog v-model="show" max-width="700">
    <v-card>
      <v-card-title>📜 Order History</v-card-title>
      <v-card-text>
        <v-list v-if="order?.history?.length">
          <v-list-item v-for="h in order.history" :key="h.id">
            <v-list-item-content>
              <v-list-item-title>Status: {{ h.status }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ h.executed_at }}<br />
                <span class="text-xs">{{ h.details }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div v-else>No history data available.</div>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="show = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  order: Object,
  modelValue: Boolean
})

const emit = defineEmits(['update:modelValue'])

const show = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
</script>